import { useMemo } from 'react'

import {
  DSAlert,
  DSCircularLoading,
  DSPagination,
  Table as DSTable
} from '@vr/ds-react'

import { PanelNumbers } from '../panel-numbers'
import { GeneralUnits } from '@/compositions/general-units'
import { useGeneralContext } from '@/contexts/general.context'
import { formatDateToBR } from '@/utils/format-date-to-br'

export const GeneralList = () => {
  const { tableData, numbers, isLoading, limit, page, setPage } =
    useGeneralContext()

  const mappedData = useMemo(() => {
    return tableData.map(item => ({
      ...item,
      dataInicioVigencia:
        item.dataInicioVigencia &&
        formatDateToBR(new Date(item.dataInicioVigencia))
    }))
  }, [tableData])

  return (
    <>
      {!isLoading && mappedData.length === 0 && (
        <DSAlert
          type='info'
          title={'Sem resultados para os filtros selecionados'}
          css={{ marginTop: '$sm16' }}
          hiddenBtnClose
        >
          Tente ajustar os filtros para exibir os resultados desejados
        </DSAlert>
      )}

      {mappedData.length > 0 && <PanelNumbers numbers={numbers} />}

      {mappedData.length > 0 && (
        <>
          <div
            style={{ overflowX: 'auto', width: '100%' }}
            className='contracts-table-wrapper'
          >
            <DSTable
              css={{ width: '100%', marginTop: '16px', minWidth: '900px' }}
            >
              <DSTable.Head css={{ '& th': { fontWeight: '400' } }}>
                <DSTable.Cell css={{ paddingLeft: '24px' }}>
                  Contrato
                </DSTable.Cell>
                <DSTable.Cell>CNPJ</DSTable.Cell>
                <DSTable.Cell>Grupo</DSTable.Cell>
                <DSTable.Cell>Tipo</DSTable.Cell>
                <DSTable.Cell>Status</DSTable.Cell>
                <DSTable.Cell css={{ textAlign: 'center' }}>Erro</DSTable.Cell>
                <DSTable.Cell>Data Início</DSTable.Cell>
                <DSTable.Cell css={{ paddingRight: '24px' }}> </DSTable.Cell>
              </DSTable.Head>
              <tbody>
                {mappedData.map(item => (
                  <GeneralUnits key={item.id} data={item} />
                ))}
              </tbody>
            </DSTable>
          </div>

          <div
            style={{ marginTop: '24px', width: '100%' }}
            className='pagination-clean'
          >
            <DSPagination
              total={numbers.total}
              maxPerPage={limit}
              defaultPage={page}
              nextPreview
              handleChange={setPage}
            />
          </div>
        </>
      )}

      {isLoading && <DSCircularLoading isLoading shouldBlur={true} />}
    </>
  )
}
